export default __webpack_public_path__ + "static/media/newsaid.625f0208.mp4";